import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";

export default function SimpleImageWithText({
  global,
  pathPrefix,
  customClass = "",
  content1,
  content2,
  logoImage,
  colorCodeContent1,
  colorCodeContent2,
  logoImageAlt,
  imageAltText,
  imageUrl,
}) {
  return (
    <>
      <section className={`${styles.root} ${customClass}`}>
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <div
                className="content-wrapper p-3 p-md-5  rounded-3 overflow-hidden shadow"
                style={{ backgroundColor: colorCodeContent2, color: "white" }}
              >
                {logoImage ? (
                  <div className="imageWrapper rounded-3 mx-2 mb-4 overflow-hidden">
                    <SourceFlowImage
                      src={logoImage}
                      size={"400x100"}
                      alt={logoImageAlt}
                      width="75%"
                    />
                  </div>
                ) : (
                  ""
                )}

                <SourceFlowText
                  global={global}
                  path={`${pathPrefix}.content2`}
                  type="html"
                >
                  {content2}
                </SourceFlowText>
              </div>
            </Col>
            <Col lg={6}>
              <div
                className={`content-wrapper p-3 p-md-5  rounded-3 overflow-hidden shadow`}
                style={{ backgroundColor: colorCodeContent1, color: "white" }}
              >
                <SourceFlowText
                  global={global}
                  path={`${pathPrefix}.content1`}
                  type="html"
                >
                  {content1}
                </SourceFlowText>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
